
import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import SelectStudentModal from "../AdminAttendanceEntry/SelectStudentModal";
import SelectStudentFeeModal from "../FeeStudentModal/SelectStudentFeeModal";
import useFetchClasses from "../../hooks/useFetchClasses";
import Select from "react-select";
import * as XLSX from "xlsx";
import "jspdf-autotable";
// import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";


import { jsPDF } from "jspdf"; // Import jsPDF from npm package
import { ApiUrl } from "../../../ApiUrl";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";


const AdmAttendanceEntry = () => {
  const navigate = useNavigate();

  const [academicYearId, setAcademicYearId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [sectionId, setSectionId] = useState(null);

  const [studentName, setStudentName] = useState("");
  const [classId, setClassId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [studentId, setStudentId] = useState("");
  const [statusData, setStatusData] = useState("");
  const [fromPeriod, setFromPeriod] = useState("");
  const [toPeriod, setToPeriod] = useState("");
  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [showBalanceFees, setShowBalanceFees] = useState(false);

  const [viewOption, setViewOption] = useState("viewReceipts");
  const [periodOptions, setPeriodOptions] = useState([]);

  const [isChecked, setIsChecked] = useState(true); // Default active
  const [showFees, setShowFees] = useState("F"); // Default to "Show All Students"
  const [report, setReport] = useState(null); // State to store selected report option

  const [isAllSelected, setIsAllSelected] = useState(false);
  const [feeAppFrom, setFeeAppFrom] = useState(null); // Update to store selected option
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  // Store fetched periods

  // Pagination state
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10; // You can change this as needed

  // Calculate page count
  const pageCount = Math.ceil(tableData.length / itemsPerPage);

  // Slice data for current page
  const offset = currentPage * itemsPerPage;
  const currentItems = tableData.slice(offset, offset + itemsPerPage);

  // Handle page change
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleClear = () => {
    setStudentName("");
    setClassId(null);
    setSectionId(null);
    setStatusData("");
    setFromPeriod(null);
    setToPeriod(null);
    setReport(null);
    setShowFees("F");
    setShowBalanceFees(false);
    setTableData([]); // Clear table data
    setShowTable(false); // Hide table
    setIsAllSelected(false); // Reset master checkbox
  };

  const handleToggle = () => {
    setIsChecked((prev) => !prev); // Toggle the checked state
  };

  const statusOptions = [
    { value: "1", label: "ACTIVE" },
    { value: "0", label: "INACTIVE" },
  ];

  const reportOptions = [
    { value: "C", label: "Fee Balance Report" },
  ];

  // Fetch academicYearId from localStorage
  useEffect(() => {
    const storedAcademicSessionId = localStorage.getItem("academicSessionId");
    if (storedAcademicSessionId) {
      setAcademicYearId(parseInt(storedAcademicSessionId, 10)); // Parse as a number
    } else {
      console.error("No academicSessionId found in localStorage.");
    }
  }, []);

  const dateRef = useRef(null);
  const fromClassRef = useRef(null);
  const toClassRef = useRef(null);
  const admissionNoRef = useRef(null);
  const barcodeRef = useRef(null);
  const smsToRef = useRef(null);

  const handleRowCheckboxChange = (index) => {
    const updatedTableData = [...tableData];
    updatedTableData[index].isSelected = !updatedTableData[index].isSelected;
    setTableData(updatedTableData);

    // Update master checkbox state
    const allSelected = updatedTableData.every((item) => item.isSelected);
    setIsAllSelected(allSelected);
  };

  const handleMasterCheckboxChange = () => {
    const updatedData = tableData.map((item) => ({
      ...item,
      isSelected: !isAllSelected,
    }));
    setTableData(updatedData);
    setIsAllSelected(!isAllSelected);
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // const handleSelectStudent = (selectedStudent) => {
  //   // Combine first name, middle name, and last name into one string
  //   const fullName = [
  //     selectedStudent.studentBasicDetails.first_name || "",
  //     selectedStudent.studentBasicDetails.middle_name || "",
  //     selectedStudent.studentBasicDetails.last_name || "",
  //   ]
  //     .filter(Boolean) // Remove empty strings
  //     .join(" "); // Join with a space

  //   // Populate the fields with the selected student's data
  //   setStudentId(selectedStudent.studentBasicDetails.id || ""); // Add the student ID
  //   setStudentName(fullName); // Set the full name
  //   setClassId(selectedStudent.studentBasicDetails.addmitted_class || null);
  //   setSectionId(selectedStudent.studentBasicDetails.addmitted_section || null);

  //   // Close the modal
  //   handleCloseModal();
  // };
const handleSelectStudent = (selectedStudent) => {
  // Full name comes directly from API as `studentname`
  const fullName = selectedStudent.studentname || "";

  // Use studentId (actual student) instead of nested object
  setStudentId(selectedStudent.studentId || "");

  // Set student name for display
  setStudentName(fullName);

  // Set class and section from API response
  setClassId(selectedStudent.classId || null);
  setSectionId(selectedStudent.sectionId || null);

  handleCloseModal();
};

  useEffect(() => {
    const fetchClassData = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}Class/GetAllClass`);
        const data = await response.json();

        if (data.message === "Success") {
          // Map the API data to fit the format required by React Select
          const formattedClasses = data.data.map((classItem) => ({
            value: classItem.id,
            label: classItem.classname,
          }));
          setClassOptions(formattedClasses);
          // Data loaded successfully
        }
      } catch (error) {
        console.error("Error fetching class data:", error);
      }
    };

    fetchClassData();
  }, []);

  useEffect(() => {
    const fetchSectionData = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}Section/GetAllSection/`);
        const data = await response.json();

        if (data.message === "Success") {
          // Map the API data to fit the format required by React Select
          const formattedSections = data.data.map((sectionItem) => ({
            value: sectionItem.id,
            label: sectionItem.sectionname,
          }));
          setSectionOptions(formattedSections);
        } else {
          console.error("Failed to fetch sections: ", data.message);
        }
      } catch (error) {
        console.error("Error fetching section data:", error);
      }
    };

    fetchSectionData();
  }, []);

  useEffect(() => {
    if (!academicYearId) {
      setPeriodOptions([]);
      setFromPeriod(null);
      setToPeriod(null);
      return;
    }

    const fetchPeriods = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/`);
        const result = await response.json();

        if (result.message === "success") {
          // Period IDs are session-specific; never expose periods from another
          // academic session in this report's filters.
          const options = result.data
            .filter(
              (period) => String(period.academic_id) === String(academicYearId),
            )
            .map((period) => ({
            value: period.id, // period ID as the value
            label: period.period_name, // period name as the label
            }));
          setPeriodOptions(options);
        } else {
          console.error("Failed to fetch periods:", result.message);
        }
      } catch (error) {
        console.error("Error fetching periods:", error);
      }
    };

    fetchPeriods();
  }, [academicYearId]);

  const handleSearch = async () => {
    if (!academicYearId) {
      console.error("Academic Year ID is not available");
      return;
    }

    const apiUrl = `${
      ApiUrl.apiurl
    }FEE_LEDGER/GetFEELEDGERBASEDONCONDITION/?academic_year_id=${academicYearId}${
      studentId ? `&studentId=${studentId}` : ""
    }${classId ? `&classId=${classId}` : ""}${
      sectionId ? `&sectionId=${sectionId}` : ""
    }${statusData ? `&statusdata=${statusData}` : ""}${
      fromPeriod ? `&fromperiod=${fromPeriod}` : ""
    }${toPeriod ? `&toperiod=${toPeriod}` : ""}${
      showFees ? `&showfees=${showFees}` : ""
    }${showBalanceFees ? `&showbalancefees=true` : ""}${
      report ? `&report=${report.value}` : ""
    }`;

    try {
      const response = await fetch(apiUrl);
      const result = await response.json();

      if (response.ok && result.message === "success!!") {
        const studentIds = result.data.map((student) => student.studentId); // Extract all student IDs
        setSelectedStudentIds(studentIds); // Store all student IDs in state
        setTableData(result.data);
        setShowTable(true); // Show table on successful data fetch
      } else {
        console.error("Failed to fetch data:", result.message);
        setTableData([]);
        setSelectedStudentIds([]); // Clear student IDs on failure
        setShowTable(false); // Hide table on failure
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setTableData([]);
      setSelectedStudentIds([]); // Clear student IDs on error
      setShowTable(false); // Hide table on error
    }
  };


  const handlePrint = async () => {
    if (!report) {
      alert("Please select a valid report!");
      return;
    }

    if (!fromPeriod) {
      alert("Please select Fee Due Period From before printing the Fee Balance Report.");
      return;
    }

    if (!toPeriod) {
      alert("Please select Fee Due Period To before printing the Fee Balance Report.");
      return;
    }

    // Use checked students; if none are checked, use all loaded table rows.
    const selectedRows = tableData.filter((item) => item.isSelected);
    const rowsToExport = selectedRows.length > 0 ? selectedRows : tableData;
    const studentIds = rowsToExport
      .filter((item) => item.isSelected)
      .map((item) => item.studentId);

    const finalStudentIds = studentIds.length > 0
      ? studentIds
      : rowsToExport.map((item) => item.studentId).filter(Boolean);

    if (!finalStudentIds.length) {
      alert("No students found to export.");
      return;
    }

    // Fee Balance Report must export the same data columns shown in the ledger
    // table, rather than the detailed/raw response from the receipt endpoint.
    if (report.value === "C") {
      const exportData = rowsToExport.map((item, index) => ({
        "Sr. No": index + 1,
        "Student Name": item.studentname,
        "Admission No": item.school_admission_no,
        BarCode: item.barcode,
        Class: item.classname,
        Section: item.sectionname,
        "Father Name": item.fatherName,
        "Mother Name": item.motherName,
        "Total Fees": item.total_fees,
        "Fees Paid": item.total_paid,
        Discount: item.discount_fees,
        Balance: item.remaining_fees,
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Fee Balance Report");
      XLSX.writeFile(workbook, `${report.label}.xlsx`);
      alert("Report downloaded successfully!");
      return;
    }

    try {
      let url = "";

      // Excel export from currently loaded table rows
      if (report.value === "F") {
        const exportData = rowsToExport.map((item, index) => ({
          "Sr. No": index + 1,
          "Student Name": item.studentname,
          "Admission No": item.school_admission_no,
          BarCode: item.barcode,
          Class: item.classname,
          Section: item.sectionname,
          "Father Name": item.fatherName,
          "Mother Name": item.motherName,
          "Total Fees": item.total_fees,
          "Fees Paid": item.total_paid,
          Discount: item.discount_fees,
          Balance: item.remaining_fees,
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
        XLSX.writeFile(workbook, `${report.label}.xlsx`);

        alert("Report downloaded successfully!");
        return;
      }

      //  API endpoints
      switch (report.value) {
        case "A":
          url = `${
            ApiUrl.apiurl
          }FEE_LEDGER/GetStudentFeeDueReceiptStudentId/?academic_year_id=${academicYearId}&studentIds=${JSON.stringify(finalStudentIds)}`;
          if (fromPeriod) url += `&feeappfrom=${fromPeriod}`;
          break;
        case "B":
          url = `${
            ApiUrl.apiurl
          }FEE_LEDGER/GetStudentMonthReceiptStudentId/?academic_year_id=${academicYearId}&studentIds=${JSON.stringify(finalStudentIds)}`;
          if (fromPeriod) url += `&feeappfrom=${fromPeriod}`;
          break;
        case "C":
          url = `${
            ApiUrl.apiurl
          }FEE_LEDGER/GetStudentFeeBalanceReceiptStudentId/?academic_year_id=${academicYearId}&studentIds=${JSON.stringify(finalStudentIds)}`;
          if (fromPeriod) url += `&feeappfrom=${fromPeriod}`;
          if (toPeriod) url += `&feeappto=${toPeriod}`;
          break;
        case "E":
          url = `${
            ApiUrl.apiurl
          }FEE_LEDGER/GetStudentPaymentMethodWiseReceiptStudentId/?academic_year_id=${academicYearId}&studentIds=${JSON.stringify(finalStudentIds)}`;
          break;
        case "G":
          url = `${
            ApiUrl.apiurl
          }FEE_LEDGER/GetStudentMonthlyElementWiseReceiptStudentId/?academic_year_id=${academicYearId}&studentIds=${JSON.stringify(finalStudentIds)}`;
          if (fromPeriod) url += `&feeappfrom=${fromPeriod}`;
          if (toPeriod) url += `&feeappto=${toPeriod}`;
          break;
        default:
          alert("The selected report is not supported.");
          return;
      }

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data?.message === "success" && data?.data?.length) {
        const reportData = data.data;
        const worksheet = XLSX.utils.json_to_sheet(reportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
        XLSX.writeFile(workbook, `${report.label}.xlsx`);
        alert("Report downloaded successfully!");
      } else {
        alert("No data found for the selected report.");
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
      alert("Failed to fetch report data. Please try again.");
    }
  };

const handleExportToExcel = () => {
  if (!tableData.length) {
    alert("No data available to export!");
    return;
  }

  // Export selected rows if any are checked, otherwise export all currently loaded rows
  const selectedRows = tableData.filter((item) => item.isSelected);
  const rowsToExport = selectedRows.length > 0 ? selectedRows : tableData;

  const exportData = rowsToExport.map((item, index) => ({
    "Sr. No": index + 1,
    "Student Name": item.studentname,
    "Admission No": item.school_admission_no,
    BarCode: item.barcode,
    Class: item.classname,
    Section: item.sectionname,
    "Father Name": item.fatherName,
    "Mother Name": item.motherName,
    "Total Fees": item.total_fees,
    "Fees Paid": item.total_paid,
    Discount: item.discount_fees,
    Balance: item.remaining_fees,
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Student Fee Ledger");
  XLSX.writeFile(workbook, "Student_Fee_Ledger.xlsx");

  alert("Report downloaded successfully!");
};

  const handleViewClick = async (academicYearId, studentId) => {
    const academicSessionId = localStorage.getItem("academicSessionId");
    const finalAcademicYearId = academicYearId || academicSessionId;

    if (!finalAcademicYearId) {
      alert("Academic year ID not found.");
      return;
    }

    try {
      console.log(
        "Fetching data for Academic Year ID:",
        finalAcademicYearId,
        "Student ID:",
        studentId
      ); // Log the IDs

      const response = await fetch(
        `${ApiUrl.apiurl}FEE_LEDGER/GetStudentFeesDetailsPDFBasedOnStudentId/${finalAcademicYearId}/${studentId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Check if the response is OK
      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(`Failed to fetch data: ${errorMessage}`);
      }

      const result = await response.json();
      console.log("API response:", result); // Log the full response to inspect the data

      if (result.message === "success" && result.data) {
        generatePDF(result.data);
      } else {
        alert("No data found to generate the PDF.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alert(
        `An error occurred while fetching the data. Error: ${error.message}`
      );
    }
  };


  const generatePDF = async (data) => {
    const doc = new jsPDF("portrait", "mm", "a4");

    // Load image from public folder and convert to Base64
    const toBase64 = (url) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/jpeg"));
        };
        img.onerror = (err) => reject(err);
        img.src = url;
      });

    try {
      const sparshLogo = await toBase64("/Assets/sparsh.jpeg");

      // Define dimensions for the image
      const imgX = 10;
      const imgY = 10;
      const imgWidth = 20;
      const imgHeight = 20;

      // Add the image to the PDF
      doc.addImage(sparshLogo, "JPEG", imgX, imgY, imgWidth, imgHeight);
    } catch (error) {
      console.error("Error adding image to PDF:", error);
    }

    // Add Institution Header Text
    const pageWidth = doc.internal.pageSize.getWidth();
    const headerText = "Sparsh College of Nursing and Allied Sciences";
    const textWidth =
      (doc.getStringUnitWidth(headerText) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const textX = (pageWidth - textWidth) / 2;
    doc.setFontSize(14);
    doc.setFont("Helvetica", "bold");
    doc.text(headerText, textX, 20);

    // Student Details Table
    const studentDetails = [
      ["Student Name", data.studentname, "Session", data.session_code],
      ["Father Name", data.fathername, "Class", data.classname],
      ["Mother Name", data.mothername, "Section", data.sectionname],
      ["Admission No", data.admission_no, "Barcode", data.barcode],
    ];

    doc.autoTable({
      startY: 30,
      body: studentDetails,
      margin: { top: 10 },
      tableWidth: 180,
      didDrawCell: (data) => {
        doc.setDrawColor(0);
        doc.rect(
          data.cell.x,
          data.cell.y,
          data.cell.width,
          data.cell.height,
          "S"
        );
      },
    });

    // Fee Details Table
    const monthOrderMap = {
      "january": 1,
      "february": 2,
      "march": 3,
      "april": 4,
      "may": 5,
      "june": 6,
      "july": 7,
      "august": 8,
      "september": 9,
      "october": 10,
      "november": 11,
      "december": 12
    };

    const sortedFeesDetails = [...(data.feesdetails || [])].sort((a, b) => {
      const monthA = a.periodName ? a.periodName.trim().toLowerCase() : "";
      const monthB = b.periodName ? b.periodName.trim().toLowerCase() : "";
      
      const orderA = monthOrderMap[monthA] || 999;
      const orderB = monthOrderMap[monthB] || 999;
      
      if (orderA !== orderB) {
        return orderA - orderB;
      }
      
      const nameA = a.element_name ? a.element_name.toLowerCase() : "";
      const nameB = b.element_name ? b.element_name.toLowerCase() : "";
      return nameA.localeCompare(nameB);
    });

    const feeDetails = sortedFeesDetails.map((fee) => [
      fee.periodName,
      fee.element_name,
      fee.total_amount,
      fee.paid_amount,
      fee.remaining_amount,
    ]);


    const totalRows = [
      ["", "", "", "Total Fees", data.total_fees],
      ["", "", "", "Total Paid", data.total_paid],
      ["", "", "", "Total Discount", data.total_discount],
      ["", "", "", "Balance", data.remaining_amount],
    ];

    feeDetails.push(...totalRows);

    doc.autoTable({
      startY: doc.previousAutoTable.finalY + 10,
      head: [["Fee Period", "Fee Element", "Total Amt.", "Paid", "Balance"]],
      body: feeDetails,
      tableWidth: 180,
      didDrawCell: (data) => {
        doc.setDrawColor(0);
        doc.rect(
          data.cell.x,
          data.cell.y,
          data.cell.width,
          data.cell.height,
          "S"
        );
      },
    });

    // Convert PDF to Blob
    const pdfBlob = doc.output("blob");
    const blobUrl = URL.createObjectURL(pdfBlob);
    window.open(blobUrl, "_blank");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <p className="text-center fw-bold" style={{ fontSize: "20px" }}>
                STUDENT FEE LEDGER
              </p>

              {/* Button Group */}

              <div className="row mb-3 mt-3  mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handlePrint}
                  >
                    Print
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleExportToExcel}
                  >
                    Export to Excel
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              {/* Form Fields */}
              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="row">
                    <div className="col-12 col-md-3 mb-3">
                      <label htmlFor="student-name" className="form-label">
                        Student Name
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          className="form-control detail"
                          placeholder="Enter student name"
                          value={studentName}
                          onChange={(e) => setStudentName(e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-primary ms-2"
                          onClick={handleOpenModal}
                          style={{ width: "50px", padding: "3px" }}
                        >
                          ...
                        </button>
                      </div>
                    </div>

                    <SelectStudentFeeModal
                      show={showModal}
                      handleClose={handleCloseModal}
                      onSelectStudent={handleSelectStudent}
                    />

                    <div className="col-12 col-md-3 mb-2">
                      <label htmlFor="admitted-class" className="form-label">
                        Admitted Class<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={classOptions}
                        className="detail"
                        classNamePrefix="react-select"
                        placeholder="Select Class"
                        value={
                          classOptions.find(
                            (option) => option.value === classId,
                          ) || null
                        } // Match the selected class
                        onChange={(selectedOption) =>
                          setClassId(
                            selectedOption ? selectedOption.value : null,
                          )
                        }
                      />
                    </div>

                    <div className="col-12 col-md-3 mb-2">
                      <label htmlFor="section" className="form-label">
                        Section
                      </label>
                      <Select
                        options={sectionOptions}
                        className="detail"
                        classNamePrefix="react-select"
                        placeholder="Select Section"
                        value={
                          sectionOptions.find(
                            (option) => option.value === sectionId,
                          ) || null
                        } // Match the selected section
                        onChange={(selectedOption) =>
                          setSectionId(
                            selectedOption ? selectedOption.value : null,
                          )
                        }
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Select
                        id="status"
                        options={statusOptions}
                        className="detail"
                        placeholder="Select Status"
                        classNamePrefix="react-select"
                        ref={toClassRef}
                        defaultValue={statusOptions.find(
                          (option) => option.value === "1",
                        )}
                        onChange={(selectedOption) => {
                          console.log("Selected Status: ", selectedOption);
                          setStatusData(
                            selectedOption ? selectedOption.value : "",
                          ); // Set selected value to state
                        }}
                      />
                    </div>

                    {/* <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="fee-due-period-from"
                        className="form-label"
                      >
                        Fee Due Period From
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        options={periodOptions} // Use the fetched period options
                        placeholder="Select Period"
                        isClearable
                        value={
                          fromPeriod
                            ? {
                                value: fromPeriod,
                                label: periodOptions.find(
                                  (option) => option.value === fromPeriod
                                )?.label,
                              }
                            : null
                        } // Select the value if available
                        onChange={(selectedOption) =>
                          setFromPeriod(
                            selectedOption ? selectedOption.value : ""
                          )
                        } // Update fromPeriod state
                      />
                    </div> */}

                    <div className="col-12 col-md-3 mb-3">
                      <label
                        htmlFor="fee-due-period-from"
                        className="form-label"
                      >
                        Fee Due Period From
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        className="detail"
                        options={periodOptions} // Use the fetched period options
                        placeholder="Select Period"
                        value={
                          fromPeriod
                            ? {
                                value: fromPeriod,
                                label: periodOptions.find(
                                  (option) => option.value === fromPeriod,
                                )?.label,
                              }
                            : null
                        }
                        onChange={(selectedOption) =>
                          setFromPeriod(
                            selectedOption ? selectedOption.value : null,
                          )
                        } // Update fromPeriod state
                      />
                    </div>

                    <div className="col-12 col-md-3 mb-2">
                      <label htmlFor="fee-due-period-to" className="form-label">
                        Fee Due Period To
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        className="detail"
                        options={periodOptions} // Use the fetched period options
                        placeholder="Select Period"
                        value={
                          toPeriod
                            ? {
                                value: toPeriod,
                                label: periodOptions.find(
                                  (option) => option.value === toPeriod,
                                )?.label,
                              }
                            : null
                        } // Select the value if available
                        onChange={(selectedOption) =>
                          setToPeriod(
                            selectedOption ? selectedOption.value : "",
                          )
                        } // Update toPeriod state
                      />
                    </div>

                    <div className="col-12 col-md-3 mb-2">
                      <label htmlFor="report" className="form-label">
                        Report
                      </label>
                      <Select
                        id="report"
                        className="detail"
                        options={reportOptions}
                        placeholder="Select Report"
                        classNamePrefix="react-select"
                        value={report}
                        ref={toClassRef}
                        onChange={(selectedOption) => {
                          console.log("Selected Report: ", selectedOption);
                          setReport(selectedOption);
                        }}
                      />
                    </div>

                    {/* Radio Buttons Section */}
                    <div className="col-12 col-md-12 mb-3 mt-3">
                      <div
                        className="d-flex flex-wrap gap-3 justify-content-start align-items-start p-3"
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                        }}
                      >
                        <div className="form-check me-3">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault1"
                            value="F"
                            checked={showFees === "F"}
                            onChange={(e) => {
                              setShowFees(e.target.value);
                              setShowBalanceFees(false);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault1"
                          >
                            Show Students With Fees
                          </label>
                        </div>

                        <div className="form-check me-3">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault2"
                            value="A"
                            checked={showFees === "A"}
                            onChange={(e) => {
                              setShowFees(e.target.value);
                              setShowBalanceFees(false);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault2"
                          >
                            Show All Students
                          </label>
                        </div>

                        <div className="form-check me-3">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault3"
                            value="Z"
                            checked={showFees === "Z"}
                            onChange={(e) => {
                              setShowFees(e.target.value);
                              setShowBalanceFees(false);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault3"
                          >
                            Show Students with Zero Fees Only
                          </label>
                        </div>

                        <div className="form-check me-3">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault4"
                            checked={showBalanceFees}
                            onChange={() => {
                              setShowFees("");
                              setShowBalanceFees(true);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault4"
                          >
                            Show Students with Balance Fees
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {showTable && (
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sr. No</th>
                          <th>Student Name</th>
                          <th>Admission No</th>
                          <th>BarCode</th>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Father Name</th>
                          <th>Mother Name</th>
                          <th>Total Fees</th>
                          <th>Fees Paid</th>
                          <th>Discount</th>
                          <th>Balance</th>
                          <th>View</th>
                          <th>
                            Print
                            <br />
                            <input
                              type="checkbox"
                              checked={isAllSelected}
                              onChange={handleMasterCheckboxChange}
                            />
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems.length > 0 ? (
                          currentItems.map((item, index) => (
                            <tr key={item.studentId ?? `${offset}-${index}`}>
                              <td>{offset + index + 1}</td> {/* Sr. No */}
                              <td>{item.studentname}</td>
                              <td>{item.school_admission_no}</td>
                              <td>{item.barcode}</td>
                              <td>{item.classname}</td>
                              <td>{item.sectionname}</td>
                              <td>{item.fatherName}</td>
                              <td>{item.motherName}</td>
                              <td>{item.total_fees}</td>
                              <td>{item.total_paid}</td>
                              <td>{item.discount_fees}</td>
                              <td>{item.remaining_fees}</td>
                              <td>
                                <button
                                  className="btn btn-link"
                                  onClick={() =>
                                    handleViewClick(
                                      item.academic_year_id,
                                      item.studentId,
                                    )
                                  }
                                >
                                  View
                                </button>
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={item.isSelected || false}
                                  onChange={() =>
                                    handleRowCheckboxChange(offset + index)
                                  }
                                />
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="14" className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={
                      "pagination justify-content-center mt-3"
                    }
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    activeClassName={"active"}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
